import _ from 'lodash';
import Emitter from '../../services/emitter';
import Config from '../../config';
import mElectronApi from '../../util/electron';
import MenuAction from '../menu/action';
import Mscratch from '../../services/mscratch';
import { onNew, onOpen, onSave, onImport, onExport } from './project';
import { onUndo, onRedo, onClickUploadFirmware, checkUpdate } from './common';
import History from '../../util/history';
import projectModel from '../../model/project.model';

export default (store) => {

    /**
     * 点击检查更新执行的事件
     *
     */
    const onClickCheckUpdate = () => {
        checkUpdate(store, false);
    };

    const onClickGuide = () => {
        const { intlr } = store.getState();
        const link = Config.link.guide[_.has(Config.link.guide, intlr.langKey) ? intlr.langKey : 'en'];
        mElectronApi.openLink(null, link);
    };

    const onClickExit = () => {
        Emitter.emit('ConfirmCloseWindow');
    };

    const onClickBackGo = () => {
        const { project } = store.getState();
        if (!project.isLoaded) {
            return;
        }
        if (projectModel.isSaved()) {
            History.replace('/list');
        } else {
            History.replace({
                pathname: '/confirm/save/list'
            });
        }
        // 清除Mscratch的侧边栏
        Mscratch.clearLayout();
        // 清除Ai弹框
        if (window.mediaWindow) {
            window.mediaWindow.ctx.close();
        }
    };

    const onOpenWebFiles = (type) => {
        type = type || 'projects';
        History.replace(`/projects?${type}`);
    };

    const onSaveas = () => {
        History.replace('/web/saveas');
    };

    /**
     * 处理点击菜单事件的配置
     */
    const handleClickMenuConfig = {
        'MENU.FILE.NEW': () => onNew(),
        'MENU.FILE.OPEN': () => onOpen(),
        'MENU.FILE.SAVE': () => onSave(),
        'MENU.FILE.SAVEAS': () => onSave(true),
        'MENU.EDIT.UNDO': onUndo,
        'MENU.EDIT.REDO': onRedo,
        'MENU.HELP.UPDATER.CHECKER': onClickCheckUpdate,
        'MENU.FIRMWARE': onClickUploadFirmware,
        'MENU.HELP.GUIDE': onClickGuide,
        'MENU.EXIT': onClickExit,
        'MENU.BACKGO': onClickBackGo,

        'MENU.FILE.NEW.WEB': onNew,
        'MENU.SHOW_WEB_PROJECT_PANEL': onOpenWebFiles,
        'MENU.FILE.SAVE.WEB': onSave,
        'MENU.FILE.SAVEAS.WEB': onSaveas,
        'MENU.FILE.IMPORT': onImport,
        'MENU.FILE.EXPORT': onExport,

    };

    /**
     * 点击菜单事件
     *
     * @param {any} key
     */
    const onClickMenu = key => {
        if (_.has(handleClickMenuConfig, key)) {
            handleClickMenuConfig[key]();
        }
    };

    /**
     * 设置菜单操作状态
     *
     * @param {any} data
     */
    const onSetMenuOperate = (data) => {
        const { operate } = store.getState().menu;
        if (!_.isEqual(operate, data)) {
            store.dispatch(MenuAction.setOperate(data));
        }
    };

    /**
     * 可以隐藏弹出菜单，如果有的话
     *
     */
    const onCanHideOpenedMenu = () => {
        // TODO 可以优化，多长时间内只触发一次
        const { main, user } = store.getState().menu;
        if (main) {
            document.querySelector('#mainMenuTrigger').click();
        }
        if (user) {
            document.querySelector('#userMenuTrigger').click();
        }
    };

    Emitter.on('ClickMenu', onClickMenu);
    Emitter.on('SetUndoRedoOperate', onSetMenuOperate);
    Emitter.on('CanHideOpenedMenu', onCanHideOpenedMenu);
};